import styled from 'styled-components';
import { ActionButton } from '@womcorp/wom-miwom-ui-kit/dist/components/Button';

const ActionButtonStyled = styled(ActionButton)`
  && {
    grid-column: ${({ centerbutton }) => (centerbutton ? '2/3;' : '')};
    ${({ $isNew }) => $isNew && 'margin-top: 8px;'}

    border: 1px solid #c9cfd7;
    box-shadow: none;
    height: 96px;
    position: relative;

    :hover {
      border-color: #4d008c;
    }
    img,
    svg {
      width: 40px;
      height: 40px;
      margin-bottom: 4px;
    }

    span {
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: #0e141d;
    }

    :before {
      background: #dbcce8;
      border-radius: 4px;
      content: ${({ $isNew }) => ($isNew ? `'Nuevo'` : 'none')};
      color: #4d008c;
      font-size: 11px;
      line-height: 16px;
      padding: 0 4px;
      position: absolute;
      top: -8px;
    }

    @media (min-width: 769px) {
      height: 112px;
      width: 128px;
    }
  }
`;

export { ActionButtonStyled };
